
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import '@fortawesome/fontawesome-free/css/all.min.css';
import '../App.css';
import emailjs from 'emailjs-com';
import ContactImg from '../images/shree-engineers-mages--scaled.webp'; // अपनी image का सही path डालें
import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
function ContactHome() {
     const [userData, setUserData] = useState({});
      const [aadhaarFile, setAadhaarFile] = useState(null);
      const navigate = useNavigate();
    
      const handleChange = (e) => {
        const { name, value } = e.target;
        setUserData({ ...userData, [name]: value });
      };
    
      const handleFileChange = (e) => {
        setAadhaarFile(e.target.files[0]);
      };
    
      const handleSubmit = async (e) => {
        e.preventDefault();
        const formData = new FormData();
    
        Object.entries(userData).forEach(([key, value]) => {
          formData.append(key, value);
        });
    
      
        try {
          const response = await fetch("https://api.solarclubbharat.com/publicApi/createContact", {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
          });
          const data = await response.json();
    
            if (response.ok) {
        alert(data.message || "Enquiry submitted successfully!");
      
      }  else {
            toast.error(data.message || "Registration failed");
          }
        } catch (error) {
          toast.error("Something went wrong.");
        }
      }; 
  return (
    <div className="container-fluid py-5" style={{ background: 'linear-gradient(90deg, #f5f3f3ff, #e6e1e1ff)' }}>
      <div className="container-fluid">
        <div className="row align-items-center p-3">
          {/* Left Side - Image */}
          <div className="col-12 col-md-6 ps-0 my-4">
            <img
              src="https://media.istockphoto.com/id/1566721185/vector/people-install-configure-solar-panel-system.jpg?s=612x612&w=0&k=20&c=BOHntrBqjbLyAUO62blOmYGmgrO4x1V-j2_0AzyTllg="
              alt="Contact"
              className="rounded-4 shadow w-100 product-img-out"
             
            />
          </div>

          {/* Right Side - Form */}
          <div className="col-12 col-md-6 bg-white rounded-4 shadow p-4 my-4">
            <h1 className="text-uppercase fw-bold" style={{ color: '#079000'}}>
              Contact Us
            </h1>
            <h2 className="fw-bold" style={{ color: '#079000'}}>
              Get in Touch with SOLAR CLUB BHARAT
            </h2>

            {/* Success/Error Message */}
            {/* {message && <div className="alert alert-info">{message}</div>} */}

            <form >
              <div className="row g-3">
                {/* First + Last Name */}
                <div className="col-12">
                  <label className="form-label">
                    Name <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    name="name"
                    className="form-control"
                    placeholder="Enter First Name"
                    required
                 onChange={handleChange} />
                </div>
                <div className="col-12">
                  <label className="form-label">City</label>
                  <input
                    type="text"
                    name="address"
                    className="form-control"
                    placeholder="Enter Your City"
                 onChange={handleChange} />
                </div>

                {/* Email + Phone */}
                <div className="col-12">
                  <label className="form-label">
                    Email <span className="text-danger">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    className="form-control"
                    placeholder="Email Address"
                    required
                 onChange={handleChange} />
                </div>
                <div className="col-12">
                  <label className="form-label">
                    Phone Number <span className="text-danger">*</span>
                  </label>
                  <input
                    type="tel"
                    name="mobile"
                    className="form-control"
                    placeholder="9950xxxxx18"
                    required
                 onChange={handleChange} />
                </div>

                {/* Subject */}
                {/* <div className="col-12">
                  <label className="form-label">Subject</label>
                  <input type="text" name="subject" className="form-control" placeholder="Subject" onChange={handleChange}/>
                </div> */}

                {/* Message */}
                {/* <div className="col-12">
                  <label className="form-label">Message</label>
                  <textarea
                    name="message"
                    className="form-control"
                    rows="4"
                    placeholder="Your Message"
                 onChange={handleChange} ></textarea>
                </div> */}

                {/* Submit */}
                <div className="col-12">
                  <button type="submit" className="btn px-4 fw-bold" style={{ backgroundColor: '#079000'}} onClick={handleSubmit}>
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ContactHome;
